module.exports = __webpack_public_path__ + "static/img/icon-home.48a9aa7.png";